document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Mobile nav ---------- */
  var navToggle = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      if (nav.hasAttribute('data-open')) {
        nav.removeAttribute('data-open');
      } else {
        nav.setAttribute('data-open', '');
      }
    });
  }

  /* ---------- Predictive search drawer ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchDrawer = document.querySelector('[data-search-drawer]');
  var searchClose = document.querySelector('[data-search-close]');
  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', function (e) {
      e.preventDefault();
      searchDrawer.hidden = false;
      var input = searchDrawer.querySelector('input[type="search"]');
      if (input) input.focus();
    });
  }
  if (searchClose && searchDrawer) {
    searchClose.addEventListener('click', function () {
      searchDrawer.hidden = true;
    });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartIcon = document.querySelector('[data-cart-icon]');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.hidden = false;
  }
  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.hidden = true;
  }

  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });

  /* Intercept "Add to cart" forms to add via AJAX and open the drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#ProductForm');
    if (!form) return;
    e.preventDefault();

    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var countEl = document.querySelector('[data-cart-count]');
        if (countEl) countEl.textContent = cart.item_count;
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
        form.submit(); // fall back to a normal page submit
      });
  });

  if (cartIcon) {
    cartIcon.addEventListener('click', function (e) {
      // Let the drawer open instead of navigating, if a drawer exists on the page.
      if (cartDrawer) {
        e.preventDefault();
        openCartDrawer();
      }
    });
  }

  /* ---------- Product option selection (visual only; wire to real variant
     matching logic per-store as variants/options are added) ---------- */
  document.querySelectorAll('.product-page__option-values').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]');
      if (!btn) return;
      group.querySelectorAll('[data-option-value]').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImage = document.getElementById('ProductMainImage');
      if (mainImage) mainImage.src = thumb.getAttribute('data-full');
    });
  });
});
